(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7140],{

/***/ 10895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16569);
/* harmony import */ var components_banner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82624);
/* harmony import */ var utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94142);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72420);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var components_contact__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);









var Menu = [{
  link: '/about/about',
  text: '关于我们',
  key: 'about'
}, {
  link: '/about/contact',
  text: '联系我们',
  key: 'contact'
}];
var pcImage = 'https://devcdn.xylink.com/xylink_website_doc/images/replace/about/pc/pc-about-banner.jpg';
var mImage = 'https://devcdn.xylink.com/xylink_website_doc/images/replace/about/mobile/m-about-banner.jpg';

var Wrap = function Wrap(props) {
  var title = props.title,
      children = props.children,
      _props$pageKey = props.pageKey,
      pageKey = _props$pageKey === void 0 ? 'about' : _props$pageKey,
      _props$customClass = props.customClass,
      customClass = _props$customClass === void 0 ? '' : _props$customClass;
  var size = (0,utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("title", {
        children: title
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("section", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_banner__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        bgImage: size.width < 768 ? mImage : pcImage,
        menu: Menu,
        pageKey: pageKey,
        title: " "
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: customClass,
        children: children
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_contact__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().contact)
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Wrap);

/***/ }),

/***/ 82624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IndexView; }
/* harmony export */ });
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78402);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function IndexView(props) {
  var pageKey = props.pageKey,
      _props$menu = props.menu,
      menu = _props$menu === void 0 ? [] : _props$menu,
      title = props.title,
      bgImage = props.bgImage,
      _props$bgImageMobile = props.bgImageMobile,
      bgImageMobile = _props$bgImageMobile === void 0 ? bgImage : _props$bgImageMobile,
      className = props.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["for-pc"]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("header", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().header),
        style: {
          backgroundImage: "url(".concat(bgImage, ")")
        },
        children: title
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["for-mobile"]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("header", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().header),
        style: {
          backgroundImage: "url(".concat(bgImageMobile, ")")
        },
        children: title
      })
    }), menu.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("nav", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().nav),
      children: menu.map(function (item) {
        var key = item.key,
            text = item.text,
            _item$target = item.target,
            target = _item$target === void 0 ? '_self' : _item$target;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
          className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().navItem), pageKey === item.key && (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active)),
          target: target,
          rel: "noreferrer",
          href: item.link,
          children: text
        }, key);
      })
    })]
  });
}

/***/ }),

/***/ 53784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IndexView */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5951);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89231);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var IndexView = function IndexView(props) {
  var className = props.className,
      _props$isTry = props.isTry,
      isTry = _props$isTry === void 0 ? true : _props$isTry,
      _props$btnType = props.btnType,
      btnType = _props$btnType === void 0 ? 'banner' : _props$btnType,
      btnWidth = props.btnWidth;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().btnGroup), !!className && className),
    children: [isTry && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      category: btnType,
      btnWidth: btnWidth,
      type: "primary",
      color: "green",
      className: 'btnTry',
      href: "/try",
      children: "\u7ACB\u5373\u8BD5\u7528"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      category: btnType,
      btnWidth: btnWidth,
      type: "primary",
      href: "/contact",
      children: "\u8054\u7CFB\u9500\u552E"
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (IndexView);

/***/ }),

/***/ 62872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_about_wrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10895);
/* harmony import */ var styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43755);
/* harmony import */ var styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var introduce = ['小鱼易连——云视频国家队，荣获中国电子等数家国资企业的战略投资赋能，并作为信创工委会成员单位，以安全可信的自主技术，打造“高安全·超融合·全连接”云视频，为政府、政法、金融、教育、医疗等行业及企业用户提供数字化服务，助力数字中国战略落地。', '自2014年成立以来，小鱼易连持续坚持技术创新，在北京、深圳、西安、武汉、成都、郑州设有六大研究院，并在全国各地部署诸多运营机构。对自主核心技术的深入研究和投入，令小鱼易连全面掌握核心自主知识产权，已拥有百余项云视频专利技术与软件著作权，并在业内创新推出“超融合视频平台+全连接视频终端+泛业务开发底座”综合方案，全面推动各行各业数字化升级。', '多年行业深耕，小鱼易连已深入到政务、政法、教育、保险、银行、医疗、制造、石油、电力、建筑、高科技电子等领域，服务超过16万家大中型客户，包括50多家国家部委和中央企业，以及300多家省市政府机构，建设运营了超大规模的政务云视频服务平台。根据IDC《中国视频会议与协作市场跟踪报告（2019年、2020年和2021年）》，小鱼易连蝉联中国网络会议市场占有率第一。', '同时，在工信部电子信息司和信息技术发展司指导下，中国电子技术标准化研究院联合小鱼易连、国家信息中心等发布了云视频首个行业白皮书——《云视频关键技术及标准化白皮书》，共同制定云视频行业技术标准、推动产业发展。', '秉承“建设有核心自主知识产权的高科技民族企业”的使命，小鱼易连将一如既往以“为客户创造价值”为第一驱动力，并携手广大战略合作伙伴一起，用科技振兴民族，让世界零距离。'];
var honor = [{
  prize: 'https://sdk-source.xylink.com/website/assets/home/honor2023M.png',
  year: '2023',
  items: ['IDC 中国私有云会议市场占有率第一', '上海市科技小巨人企业', '2023胡润全球未来独角兽', '2023中国隐形独角兽500强（位列前100名）', '入选中国信通院《高质量数字化转型产品\n及服务全景图》', '数字中国典型方案与实践案例-年度优秀解决\n方案', '应急管理信息化产品技术创新奖', '金政奖-数字政务优秀解决方案', '优秀数字化解决方案提供商', '中国信创产业优秀厂商', '数字化转型突出贡献企业奖', '信创创新产品奖', '年度前沿科技产品-最佳技术突破奖', '2023信创产业TOP100榜单', '信息技术应用创新推荐解决方案']
}, {
  prize: 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/about/2de5ed54e606fd051a7a89c49c4da5e0cd4fea6e03bb9a7ece8150b58dafa11a.png',
  year: '2022',
  items: ['2022数字政府创新方案提供商', '2022年度优秀数字化解决方案提供商', '2021年度信息技术应用创新典型解决方案', '2022云视频行业领航企业', '信创产业十大赛道先锋力量-云视频创新奖', '中国信息自主潜在独角兽企业', '中国信创厂商精选60强', '数字企业卓越服务商', '2022创新场景50-最佳云视频场景实践奖']
}, {
  prize: 'https://testdevcdn.xylink.com/h5/sdk_doc/static/website/02d6d7f5b0a351faed1c01bf3db17efd2ffec3084ae075ead6fea10c3f0e643b.png',
  year: '2021',
  items: ['IDC 中国网络会议市场占有率排名第一', '2021年度中国企业服务产业最佳投资案例TOP10', '2021投中榜·锐公司100榜单', '2021科技创新引领奖', '智慧司法创新方案奖', '数字政府最佳实践奖', '优秀数字化解决方案提供商', '数字新经济·云视频领域领军企业', '数字新基建·云视频解决方案首选服务商', '数字新经济·企业数字化转型最具影响力企业', '数字新基建·最佳政务云视频解决方案奖', '智慧高校解决方案创新奖']
}, {
  prize: 'https://devcdn.xylink.com/xylink_website_doc/images/about/about-us/m/glory-2020.png',
  year: '2020',
  items: ['IDC 中国网络会议市场占有率排名第一', '新基建产业独角兽', '中国科创企业百强榜', '最佳协同办公解决方案奖', '发布云视频首个行业白皮书', '中国软件技术领军企业', '全国数字生态优秀应用案例', '最具竞争力企业、最具影响力企业']
}, {
  prize: 'https://devcdn.xylink.com/xylink_website_doc/images/about/about-us/m/glory-2019.png',
  year: '2019',
  items: ['IDC 中国网络会议市场占有率排名第一', '真榜·2018中国互联网“逆生长”准独角兽公司TOP50', 'Gartner 2019 Cool Vendors', '智慧司法优秀解决方案奖', '智慧会议系统标准工作组成员单位', '36Kr WISE 2019新商业引领者100榜', '中国企业家 中国科创企业百强榜', '嘉宾大学&人民日报数字版 2019科创榜POWER100榜', 'GNTC IPv6先锋企业', '中国现代办公设备协会 优秀制造厂商', '36kr 新经济之王·企业服务应用服务之王', 'i黑马 企业通用服务独角兽', '创业邦 2019中国创新成长企业100强', '创业邦 卓业企业应用提供商TOP 5', '钛媒体 年度企业社会责任先锋', '慧聪网 十大音视频品牌', '极客公园 社会效率推动力榜单', '2019年度企业级会议协作系统星标大奖']
}, {
  prize: '/v2/images/about/mobile/4.png',
  year: '2018',
  items: ['全国政法智慧司法十大解决方案提供商', '2018年度CIO 最信赖服务商奖', '中国教育行业发展论坛 2018优秀品牌奖', 'GET2018碰撞演变 GET荣誉嘉宾', '36Kr新经济之王 企业服务最具影响力奖', '创业邦 中国企业服务创新成长50强', '猎云网 最佳企业服务商', 'i黑马2018 企业服务产业独角兽', '钛媒体 年度CSR先锋', '品途NBI Awards商业影响力 年度企业服务奖', '品途NBI Awards商业影响力 年度人物']
}, {
  prize: '/v2/images/about/mobile/1.png',
  year: '2017',
  items: ['赛迪集团 2017 云视频会议行业领军企业', '赛迪集团 2017 云视频会议行业领军人物', '2017 创业邦 100-中国创新成长企业 100 强', 'CIO 时代最信赖供应商奖', 'CIO 时代大数据人物奖', '钛媒体 2017 年度前沿科技产品奖', '36Kr 年度最具影响力企业服务 TOP 奖', '中关村在线2017 年度推荐产品大奖']
}, {
  prize: '/v2/images/about/mobile/2.png',
  year: '2016',
  items: ['入选中关村创业大街 “创新先锋 2016”榜单', '2016 未来医疗 100 强', '正和岛亿+计划入围产品', '中国联通优秀贡献奖', '2016 中国视频应用产品创新奖', 'T100 新技术新产品创新力行动奖']
}, {
  prize: '/v2/images/about/mobile/3.png',
  year: '2015',
  items: ['中国现代办公设备协会推荐创新产品奖', '2015 中国年度创新成长企业 100 强', '中关村新技术新产品证书', '德勤中关村明日之星', '第四届中国国际消费电子 Leader 工业设计奖', '第四届全国创新创业大赛北京赛区一等奖', '第四届中国国际消费电子 Leader 创新奖', '海帆企业证书', '第十七届高交会优秀成果奖', '中关村高新技术企业证书', '中国最具投资价值企业 60 强', '国家高新技术企业证书']
}];

var About = function About() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(components_about_wrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    title: "\u5173\u4E8E\u6211\u4EEC",
    pageKey: "about",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: (styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4___default().introduce),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
        children: "\u516C\u53F8\u4ECB\u7ECD"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4___default().desc),
        children: introduce.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            children: item
          }, index);
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        id: "honer"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: (styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4___default().honor),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
        children: "\u516C\u53F8\u8363\u8A89"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
        src: "https://testdevcdn.xylink.com/h5/sdk_doc/static/website/81f680c07ebc7bc861febe06dcf280a6f167d07bfd4da5de542cb1f68796ebb1.jpg",
        alt: "\u516C\u53F8\u8363\u8A89",
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4___default().banner), 'for-pc')
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4___default().glory),
        children: honor.map(function (item) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
            className: (styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["glory-item"]),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
              src: item.prize,
              className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('for-mobile'),
              alt: ""
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: (styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["glory-year"]),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4___default().year)),
                children: item.year
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: (styles_about_about_module_scss__WEBPACK_IMPORTED_MODULE_4___default().row),
              children: item.items.map(function (d, idx) {
                return item.year === '2023' && (idx === 4 || idx === 5) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  dangerouslySetInnerHTML: {
                    __html: "".concat(d).replace(/\n/g, '<br/>')
                  }
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  children: d
                }, d);
              })
            })]
          }, item.prize);
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (About);

/***/ }),

/***/ 94142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var UseResize = function UseResize() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    width: 0
  }),
      size = _useState[0],
      setSize = _useState[1];

  var onResize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    setSize({
      width: document.documentElement.clientWidth
    });
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    onResize();
  }, [onResize]);
  return size;
};

/* harmony default export */ __webpack_exports__["Z"] = (UseResize);

/***/ }),

/***/ 5649:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/about",
      function () {
        return __webpack_require__(62872);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72420:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"about_border__px__fi3xg","border__px-before":"about_border__px-before___47nF","border__px-before1":"about_border__px-before1__PdB4O","border-children1":"about_border-children1__t5h02","border-children2":"about_border-children2__Mnd3C","for-mobile":"about_for-mobile__FQciO","for-pc":"about_for-pc__y8reB","contact":"about_contact__XAqpm"};

/***/ }),

/***/ 78402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"banner_container__oBe7a","nav":"banner_nav__R4D9K","navItem":"banner_navItem__z8je4","header":"banner_header__8mEeU","border__px":"banner_border__px__Rkq8K","border__px-before":"banner_border__px-before__jqV1R","border__px-before1":"banner_border__px-before1__rZGud","border-children1":"banner_border-children1__cwgjz","border-children2":"banner_border-children2__7N7DQ","for-mobile":"banner_for-mobile__9iMXJ","for-pc":"banner_for-pc__zlWnK","active":"banner_active___c3ly"};

/***/ }),

/***/ 5951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"contact_border__px__DM3ZN","border__px-before":"contact_border__px-before__F0Vlr","border__px-before1":"contact_border__px-before1__wOrFT","border-children1":"contact_border-children1__bFQeI","border-children2":"contact_border-children2__8WMsP","for-mobile":"contact_for-mobile__SdQT9","for-pc":"contact_for-pc__7iuGe","btnGroup":"contact_btnGroup__Glj3p"};

/***/ }),

/***/ 43755:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"about_border__px__f_zZe","border__px-before":"about_border__px-before__2cG__","border__px-before1":"about_border__px-before1__NIEJM","border-children1":"about_border-children1__qSEhw","border-children2":"about_border-children2__VYMlh","for-mobile":"about_for-mobile__LhHFW","for-pc":"about_for-pc__abc5b","title":"about_title__Vdtcz","introduce":"about_introduce__0L8HO","desc":"about_desc__Qsx8l","honor":"about_honor__fa4Mg","banner":"about_banner__BlxmX","glory":"about_glory__TwMad","glory-item":"about_glory-item__dvIis","glory-year":"about_glory-year__Z9lhd","year-pc":"about_year-pc__Tam_n","year":"about_year__eUZ_H","row":"about_row__ykykN","year-mobile":"about_year-mobile__lgTyb"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(5649); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);